export default __webpack_public_path__ + "static/favicon-161951a6fc8aad4a09543443e4339f85.png";